import { site } from "@/content/site";
import { useCopyToClipboard } from "@/hooks/useCopyToClipboard";
import { cn } from "@/lib/cn";

type ConnectCommandProps = {
  readonly className?: string;
};

/**
 * The F8 console line players actually type to join, as a copyable chip.
 * Replaces the old static "CONNECT FIVEM.OFFSET.GG" caption.
 */
export function ConnectCommand({ className }: ConnectCommandProps) {
  const { copied, copy } = useCopyToClipboard();

  return (
    <button
      type="button"
      onClick={() => {
        void copy(site.connectCommand);
      }}
      className={cn(
        "group inline-flex max-w-full flex-wrap items-center gap-x-3 gap-y-1 rounded-xl border border-white/15 bg-brand-navy/60 px-3 py-3 backdrop-blur-sm sm:px-4",
        "font-mono text-[0.8rem] text-white/90 sm:text-base",
        "transition-colors duration-200 hover:border-brand-sky/60 hover:bg-brand-navy/80",
        "focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-sky",
        className,
      )}
    >
      <span className="select-none text-brand-sky" aria-hidden>
        &gt;
      </span>

      <span>{site.connectCommand}</span>

      <span className="animate-caret inline-block h-4 w-2 bg-brand-sky" aria-hidden />

      <span
        className={cn(
          "font-roboto text-xs uppercase tracking-widest transition-colors sm:ml-2",
          copied ? "text-brand-sky" : "text-white/45 group-hover:text-white/80",
        )}
      >
        {copied ? "Copiado" : "Copiar"}
      </span>

      <span className="sr-only" aria-live="polite">
        {copied ? "Comando copiado" : ""}
      </span>
    </button>
  );
}
